import {FormDirtyTracker} from '../Library/FormDirtyTracker';
import {shakeUnsaved} from './Form/UnsavedShake';

const PADDING = 10;

const fitInViewport = (x, y, width, height) => {
    if (x + width > window.innerWidth) {
        x = x - width;
    }

    if (x < 0) {
        x = PADDING;
    }

    if (y + height > window.innerHeight) {
        y = y - height;
    }

    if (y < 0) {
        y = PADDING;
    }

    return {x, y};
};

let activeDialog = null;
let removeListeners = null;

export const closeContextDialog = () => {
    activeDialog?.remove();
    removeListeners?.();
    activeDialog = null;
    removeListeners = null;
};

export const positionContextDialog = (elementId, mousePosition) => {
    closeContextDialog();

    const dialog = document.getElementById(elementId);
    const dirtyTracker = dialog.querySelector('form')
        ? FormDirtyTracker(dialog)
        : null;

    const closeIfSafe = () => {
        if (dirtyTracker?.isDirty()) {
            shakeUnsaved(dialog);

            return false;
        }

        closeContextDialog();

        return true;
    };

    dialog.style.opacity = '0';

    const {width, height} = dialog.getBoundingClientRect();
    const {x, y} = fitInViewport(mousePosition.x, mousePosition.y, width, height);

    dialog.style.left = `${x}px`;
    dialog.style.top = `${y}px`;
    dialog.style.opacity = '1';

    const onClickOutside = event => {
        if (event.target.isConnected && !dialog.contains(event.target)) {
            if (!closeIfSafe()) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        }
    };

    const onKeydown = event => {
        if (event.key === 'Escape') {
            if (!closeIfSafe()) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        }
    };

    document.addEventListener('click', onClickOutside, true);
    document.addEventListener('keydown', onKeydown);

    activeDialog = dialog;
    removeListeners = () => {
        dirtyTracker?.destroy();
        document.removeEventListener('click', onClickOutside, true);
        document.removeEventListener('keydown', onKeydown);
    };
};
